// Classic jewelry stone cuts/shapes offered per product (owner picks which to enable).
export const STONE_SHAPES = [
  { key: "round", label: "Round" },
  { key: "oval", label: "Oval" },
  { key: "emerald", label: "Emerald" },
  { key: "cushion", label: "Cushion" },
  { key: "elongated_cushion", label: "Elongated Cushion" },
  { key: "radiant", label: "Radiant" },
  { key: "pear", label: "Pear" },
  { key: "marquise", label: "Marquise" },
  { key: "princess", label: "Princess" },
  { key: "asscher", label: "Asscher" },
];

export const shapeLabel = (key) => (STONE_SHAPES.find((s) => s.key === key)?.label || key);
